<section class="p-2">

  <!-- Hlavička dialógu -->
  <div class="px-1">
    <lib-dialog-header
      [titulok]="'Termín hodnotenia'"
      [predmetNazov]="terminDetail ? terminDetail.nazov : ''"
      [predmetSkratka]="terminDetail ? terminDetail.skratka : ''"
      [doplnujuciText]="terminDetail ? terminDetail.datumSk + ', ' + terminDetail.cas : null">
    </lib-dialog-header>
  </div>

  <!-- Obsah dialógu so scrollovaním -->
  <mat-dialog-content class="pt-2 pb-0 px-4 scrollable-content">

    <mat-spinner *ngIf="loading" class="m-5"></mat-spinner>
    <ul *ngIf="!loading">
      <li *ngIf="terminDetail.fazaPopis">{{terminDetail.fazaPopis}}</li>
      <li *ngFor="let h of terminDetail.hodnotiaci">{{h}}</li>
      <li *ngFor="let m of terminDetail.miestnosti">{{m.kod}}</li>
      <li *ngIf="terminDetail.poznamka">{{terminDetail.poznamka}}</li>
      <li>
        <span class="fw-bold" i18n>Prihlasovanie</span>:
        <div class="ms-3">{{terminDetail.datumPrihlasOd}} <span i18n>do</span> {{terminDetail.datumPrihlasDo}}</div>
      </li>
      <li>
        <span class="fw-bold" i18n>Odhlasovanie</span>:
        <div class="ms-3">{{terminDetail.datumOdhlasOd}} <span i18n>do</span> {{terminDetail.datumOdhlasDo}}</div>
      </li>
      <li *ngIf="terminDetail.maxPocet"><span i18n>Max. počet</span>: {{terminDetail.maxPocet}}</li>
    </ul>

    <div *ngIf="terminDetail && terminDetail.studenti && terminDetail.studenti.length > 0">
      <hr/>
      <h2 i18n>Zoznam prihlásených</h2>
      <div class="m-3">
        <div class="d-flex flex-row">
          <div *ngFor="let s of studenti; last as isLast">
            <span *ngIf="s.plneMeno !== 'unknown'">{{s.plneMeno}}</span><span *ngIf="!isLast">,&nbsp;</span>
          </div>
        </div>
        <div *ngIf="nezverejneniCount > 0">
          <span i18n>nezverejnení</span>: {{nezverejneniCount}}
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <hr/>

  <!-- Akcie dialógu -->
  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button (click)="prihlasit()"><span i18n>Prihlásiť</span></button>
    <button mat-stroked-button mat-dialog-close #initialButton><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>
